import React from 'react';
import styled from 'styled-components';
import { navy } from '@zocdoc/branding/colors';
import { Icon } from './_base';

const StarSVG = styled(Icon).attrs({ viewBox: '0 0 43 40' })`
    width: 1.075em;
`;

const Star = ({ color = navy, ...props }) => (
    <StarSVG data-test="star-icon" {...props}>
        <path
            d="M10.76,40L7.11,37.34l4.13-12.63L0.47,16.92l1.4-4.29H15.14L19.24,0h4.51l4.1,12.63H41.13l1.4,4.29L31.76,24.71l4.13,12.63L32.24,40,21.5,32.16ZM21.5,27.82l10,7.27L27.63,23.37l10-7.23H25.31L21.5,4.41,17.69,16.13H5.37l10,7.23L11.54,35.09Z"
            fill={color}
        />
    </StarSVG>
);

export { Star as default, Star };
